/**
 * EncryptionStatement, sheet 43 callout 7 (mission 10 WP16 T093; FR-017, C-008, C-009; D.3, D.7, NF.1 as
 * replaced by NFR §4.1; squad S13; spec amendment 3).
 *
 * Register 37 `encryptionStatement` and nothing wider: the organization's stored files are encrypted under a
 * key unique to it, and isolation is at the data layer. No backup, database or crypto-shred claim (C-008):
 * Postgres Class 1 rows sit under the instance key, and the statement holds only once the real KMS adapter
 * lands, so it is provisional and owner-gated (DM-01M3VYK5GMZDXY4RGS9MHN0PS7; research §1.27).
 */
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { copyText } from '@/lib/provisional-copy'

export function EncryptionStatement() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{copyText('encryptionTitle')}</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-body-sm text-navy-700">{copyText('encryptionStatement')}</p>
      </CardContent>
    </Card>
  )
}
